import axios from 'axios';
import {
  BUSINESS_DATA_URL,
  BUSINESS_DATA_URL_V3,
  UPLOAD_KTP_IMAGE_URL_UPLOAD_SERVICE,
} from './constant';

export function getBusinessData() {
  return axios.get(`${BUSINESS_DATA_URL}detail`, { withCredentials: false });
}

export function getBankData() {
  return axios.get(`${BUSINESS_DATA_URL}bank-accounts`, {
    withCredentials: false,
  });
}

export function updateIdentityInfo(data) {
  const identitiesURI = `${BUSINESS_DATA_URL_V3}identities`;

  return axios.post(identitiesURI, data, {
    withCredentials: false,
  });
}

export function getIdentity() {
  return axios.get(`${BUSINESS_DATA_URL}identities`, {
    withCredentials: false,
  });
}

export function confirmReview() {
  return axios.post(`${BUSINESS_DATA_URL}kyb-status`, {
    withCredentials: false,
  });
}

export function getKybData() {
  return axios.get(`${BUSINESS_DATA_URL}identities`, {
    withCredentials: false,
  });
}

export function uploadKtpImage(data) {
  const config = {
    withCredentials: true,
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'content-type': 'multipart/form-data',
    },
  };
  return axios.post(UPLOAD_KTP_IMAGE_URL_UPLOAD_SERVICE, data, config);
}

export function linkBankAccountToOutlets(id, data) {
  return axios.post(`${BUSINESS_DATA_URL}link`, data, {
    withCredentials: false,
  });
}
